import RunnerSafeType from "../../enums/RunnerSafeType.js";

// @see https://www.mlb.com/glossary/standard-stats/stolen-base
// A stolen base occurs when a baserunner advances by taking a base to which he isn't entitled. This generally occurs when a pitcher is throwing a pitch, but it can also occur while the pitcher still has the ball or is attempting a pickoff, or as the catcher is throwing the ball back to the pitcher.

const classifiesAsStolenBase = function(runnerSafe) {
    switch (runnerSafe) {
        case RunnerSafeType.StolenBase.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsStolenBase;